import moment from 'moment-timezone'
import {useMemo} from 'react'

import {OPTIMIZER_DEFAULT_RANGE_DAYS} from '../../../../shared/constants'
import {useOptimizedSchedulesAndRuns} from '../../../../shared/hooks/api/schedules/useOptimizedSchedulesQuery'
import {usePlantConfig} from '../../../../shared/hooks/usePlantConfigData'
import {useStartOfToday} from '../../../../shared/hooks/useStartOfToday'
import {MomentRange} from '../../../../shared/selectors/time'

export const useOptimizerRange = (): MomentRange => {
  const {timezone_id: timezoneId, created_at: createdAt} = usePlantConfig()
  const optimizerRangeStart = useStartOfToday({createdAt, timezoneId})

  const {data: optimizedSchedulesAndRuns} = useOptimizedSchedulesAndRuns()

  if (!optimizedSchedulesAndRuns) {
    throw new Error('BUG: Optimized schedules and runs should be loaded before using this hook')
  }

  return useMemo(() => {
    const optimizedSchedules = optimizedSchedulesAndRuns.optimizedSchedules
    if (optimizedSchedules.length === 0) {
      const optimizerRangeEnd = optimizerRangeStart
        .clone()
        .add(OPTIMIZER_DEFAULT_RANGE_DAYS, 'days')
      return [optimizerRangeStart, optimizerRangeEnd]
    }

    const optimizedScheduleWithLatestEnd = optimizedSchedules.sort((a, b) => {
      return (
        moment(a.optimizationDetails.range.end).valueOf() -
        moment(b.optimizationDetails.range.end).valueOf()
      )
    })[optimizedSchedulesAndRuns.optimizedSchedules.length - 1]

    const optimizerRangeEnd = moment
      .utc(optimizedScheduleWithLatestEnd.optimizationDetails.range.end)
      .tz(timezoneId)
      .startOf('day')
      .add(1, 'day') // Including the end day in the range

    return [optimizerRangeStart, optimizerRangeEnd]
  }, [optimizedSchedulesAndRuns.optimizedSchedules, timezoneId, optimizerRangeStart])
}
